import ImageOptimizer from '@/components/image-optimizer';

interface Props {
  title: string;
  onClose: () => void;
}

/** 학과 시험 안내 BottomSheet 공통 헤더(타이틀 + 닫기 + 구분선) */
export default function WrittenSheetHeader({ title, onClose }: Props) {
  return (
    <>
      <div className="flex h-[56px] items-center justify-between px-1">
        <div className="h-full w-[56px]" />
        <span className="typo-16 font-extrabold text-222222">{title}</span>
        <button
          type="button"
          className="flex h-full w-[56px] cursor-pointer items-center justify-center p-0"
          onClick={onClose}
        >
          <ImageOptimizer
            src="/svg/icon_close.svg"
            alt="close"
            width={16}
            height={16}
          />
        </button>
      </div>
      <div className="h-[2px] bg-[#D6D4E2]" />
    </>
  );
}
